import { Outlet, useMatches } from '@tanstack/react-router'
import { AppSidebar } from './AppSidebar'
import { ScrollArea } from '@/components/ui/scroll-area'

export function DashboardLayout() {
  const fullHeight = useMatches({
    select: (matches) => matches.some((m) => m.staticData.fullHeight),
  })

  return (
    <>
      <AppSidebar />
      <main className="flex-1 min-h-0 min-w-0 flex flex-col bg-surface-muted">
        {fullHeight ? (
          <Outlet />
        ) : (
          <ScrollArea dualAxis scrollRestorationId="dashboard-scroll" className="flex-1 min-h-0">
            <Outlet />
          </ScrollArea>
        )}
      </main>
    </>
  )
}
